import { MediaModel } from "app/services/api/types/common/models/MediaModel";
import { DocumentPickerAsset } from "expo-document-picker";
import { View, Image, Text } from "react-native";
import { ViewDocument } from "../atoms/ViewDocument";
import { VariantProps } from "@gluestack-ui/nativewind-utils";

type ImageGridProps = {
  documents: (DocumentPickerAsset | MediaModel)[];
  className?: string;
  size?: VariantProps<typeof ViewDocument>["size"];
};

export default function ViewDocuments({
  documents,
  className,
  size = "default",
}: ImageGridProps) {
  return (
    <View className={`flex flex-row flex-wrap gap-4 ${className}`}>
      {documents.map((document) => {
        const key = "uri" in document ? document.uri : document.id;
        return <ViewDocument document={document} key={key} size={size} />;
      })}
      {!documents.length ? <Text>No documents listed</Text> : null}
    </View>
  );
}
